import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { createMarkup } from 'lib/Utils'
import { connect } from 'react-redux'
import { selectLocation } from 'store/officeLocation'
import './index.scss'

import CloseThickSVG from 'assets/images/close-thick.svg'

class MapPin extends Component {
  render () {
    const location = this.props.location
    return (
      <div className='map-pin'>
        <div className='map-pin__marker' onClick={event => this.props.selectLocation(location.id)} />
        {
          this.props.isSelected &&
          <div className='map-pin__popover'>
            <h2 className='small-title'>{location.title.rendered}</h2>
            <div>
              <p dangerouslySetInnerHTML={createMarkup(location.acf.address)} />
              <ul className='list-unstyled'>
                {location.acf.contact_emails.map((email, i) => {
                  return <li key={`loc${location.id}email${i}`}><a href={`mailto:${email.email}`}>{email.email}</a></li>
                })}
              </ul>
              <ul className='list-unstyled'>
                {location.acf.contact_numbers.map((number, i) => {
                  return <li key={`loc${location.id}phone${i}`}><strong>{number.desc}:</strong> {number.number}</li>
                })}
              </ul>
              <div className='map-pin__popover__close' onClick={event => this.props.selectLocation(false)}>
                <img src={CloseThickSVG} alt='Close' />
              </div>
            </div>
          </div>
        }
      </div>
    )
  }
}

MapPin.propTypes = {
  isSelected: PropTypes.bool,
  selectLocation: PropTypes.func,
  location: PropTypes.object
}

const mapDispatchToProps = {
  selectLocation: (locationID) => selectLocation(locationID)
}

export default connect(null, mapDispatchToProps)(MapPin)



// WEBPACK FOOTER //
// ./src/containers/MapPin/index.js